import { AssetsTableResizableColumnWidths } from './user-preferences';

const DEFAULT_WIDTH = 150;

export const DEFAULT_ASSETS_COLUMN_ORDER = [
  'status',
  'vehicleName',
  'contactEmail',
  'firstName',
  'lastName',
  'phone',
  'vehicle',
  'driver',
  'linkedVehicle',
  'linkedDrivers',
  'products',
  'lastKnownLocation',
  'lastActive',
  'invite',
  'coPilotVersion',
  'mapDataVersion',
  'osTypeVersion',
  'deviceModel',
  'mapSets',
  'assignedVehicle',
];

export const DEFAULT_ASSETS_TABLE_RESIZABLE_COLUMN_WIDTHS: AssetsTableResizableColumnWidths =
  {
    externalId: 175,
    status: 126,
    vehicleName: 175,
    contactEmail: DEFAULT_WIDTH,
    firstName: DEFAULT_WIDTH,
    lastName: DEFAULT_WIDTH,
    phone: DEFAULT_WIDTH,
    vehicle: 125,
    driver: 125,
    linkedVehicle: 175,
    linkedDrivers: DEFAULT_WIDTH,
    products: 400,
    lastKnownLocation: 200,
    lastActive: DEFAULT_WIDTH,
    invite: 125,
    coPilotVersion: DEFAULT_WIDTH,
    mapDataVersion: 166,
    osTypeVersion: 104,
    deviceModel: DEFAULT_WIDTH,
    mapSets: DEFAULT_WIDTH,
    assignedVehicle: 225,
  };

export const DEFAULT_VEHICLES_COLUMN_ORDER = [
  'vehicleName',
  'asset',
  'drivers',
  'vehicleGroups',
  'assignedAsset',
];

export const DEFAULT_VEHICLE_GROUPS_COLUMN_ORDER = [
  'vehicles',
  'routingProfiles',
  'configurationProfile',
  'speedCoachingProfile',
  'mapSets',
  'routeModifiers',
  'customPlaces',
];

export const DEFAULT_ROUTING_PROFILES_COLUMN_ORDER = [
  'vehicleGroups',
  'vehicleIcon',
  'vehicleType',
  'routingType',
  'hazmatType',
  'useAsDefaultProfile',
  'duplicate',
];

export const DEFAULT_CONFIG_PROFILES_COLUMN_ORDER = [
  'assignedGroups',
  'syncInterval',
  'oorThreshold',
  'defaultProfile',
];

export const DEFAULT_MAP_SETS_COLUMN_ORDER = [
  'regions',
  'assignedGroups',
  'useAsDefaultMapSet',
];

export const DEFAULT_ROUTE_MODIFIERS_COLUMN_ORDER = [
  'assignedGroups',
  'viewRouteModifiers',
  'useAsDefaultModifier',
];

export const DEFAULT_CUSTOM_PLACES_COLUMN_ORDER = [
  'assignedGroups',
  'viewPlaces',
  'useAsDefaultCustomPlace',
];

export const DEFAULT_DRIVERS_COLUMN_ORDER = [
  'driverName',
  'driverGroups',
  'asset',
  'vehicle',
];

export const DEFAULT_DRIVER_GROUPS_COLUMN_ORDER = ['drivers'];

export const DEFAULT_SPEED_COACHING_PROFILES_COLUMN_ORDER = [
  'assignedGroups',
  'useAsDefaultProfile',
];
